<style lang="less" scoped>
  .footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .timer {
    font-size: 32px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #ffffff;
  }
</style>

<template lang="pug">
  .footer
    .prev
      prev-button-component(@click.native='handlePrev')
    .timer {{ time | timer }}
    .next(v-if='!last')
      next-button-component(@click.native='handleNext')
    .last(v-else)
      complete-button-component(
        :text='text'
        @click.native='complete')
</template>

<script>
import PrevButtonComponent from '@/components/left_arrow_btn';
import NextButtonComponent from '@/components/right_arrow_btn';
import CompleteButtonComponent from '@/components/custom_btn';

export default {
  props: {
    time: {
      type: Number,
      default: 0,
    },
    last: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '완료',
    },
  },
  filters: {
    timer(value) {
      const sec = (value % 60).toString().padStart(2, 0);
      const min = Math.floor(value / 60).toString().padStart(2, 0);

      return `${min} : ${sec}`;
    },
  },
  methods: {
    handlePrev() {
      this.$emit('click-prev');
    },
    handleNext() {
      this.$emit('click-next');
    },
    complete() {
      this.$emit('click-complete');
    },
  },
  components: {
    PrevButtonComponent,
    NextButtonComponent,
    CompleteButtonComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/footer/timer_arrow.vue